/**
 * API Service for Video Creator App
 * Handles all communication with User Backend
 */

// Read API URL from localStorage (set during auth token exchange)
const getApiBaseUrl = () => localStorage.getItem('api_url') || 'https://app.loopai.in';

const getAuthHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  const apiKey = localStorage.getItem('api_key');
  const storedUser = localStorage.getItem('user');
  const userEmail = storedUser ? JSON.parse(storedUser).email : null;
  if (apiKey) headers['X-API-Key'] = apiKey;
  if (userEmail) headers['X-User-Email'] = userEmail;
  return headers;
};

/**
 * Fetch available AI models from Admin Backend
 */
export async function fetchAvailableModels() {
  try {
    const response = await fetch(`${getApiBaseUrl()}/api/ai/available-models`, {
      method: 'GET',
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data.capabilities || [];
  } catch (error) {
    console.error('Failed to fetch AI models:', error);
    throw error;
  }
}

/**
 * Check if user is authenticated
 */
export async function checkAuth() {
  const response = await fetch(`${getApiBaseUrl()}/api/auth/me`, {
    method: 'GET',
    headers: getAuthHeaders()
  });

  if (!response.ok) {
    throw new Error('Not authenticated');
  }

  return response.json();
}

/**
 * Get user credits
 */
export async function getCredits() {
  const response = await fetch(`${getApiBaseUrl()}/api/credits`, {
    method: 'GET',
    headers: getAuthHeaders()
  });

  if (!response.ok) {
    throw new Error('Failed to fetch credits');
  }

  return response.json();
}

export default {
  fetchAvailableModels,
  checkAuth,
  getCredits
};
